import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ContactSection from "../sections/ContactSection";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  hideContact?: boolean;
}

export default function PageLayout({
  children,
  className = "",
  hideContact = false,
}: PageLayoutProps) {
  return (
    <>
      <Nav />
      <main
        className={`bg-tan pt-24 text-text-light dark:bg-background-dark dark:text-text-dark ${className}`}
      >
        {children}
      </main>
      {!hideContact && <ContactSection />}
      <Footer />
    </>
  );
}
